export enum MessageType {
  ERROR = <any> 'error',
  ALERT = <any> 'alert',
  INFO = <any> 'info',
  SUCCESS = <any> 'success'
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/message/shared/message.enum.ts